@if (titleText || linkPath) {
    <header class="top-bar" data-crlat="topBar">
        @if (!backFunc?.observers?.length) {
            <a class="btn-back" data-crlat="btnBack" (click)="clickBackButton($event)">
                <svg>
                    <use xlink:href="#prev-arrow"></use>
                </svg>
            </a>
        } @else {
            <a class="btn-back" data-crlat="btnBack" (click)="backClickHandler()">
                <svg>
                    <use xlink:href="#prev-arrow"></use>
                </svg>
            </a>
        }
        @if (seoEnabledInCms && !isHorseRacingDetailPage && isRouteRequestSuccess) {
            <span class="top-bar-title title-bar" data-crlat="topBarTitle" (click)="titleClickHandler()">
                @if (iconId) {
                    <svg-list [list]="iconSvg"></svg-list>
                }
                @if (titleText) {
                    <a [attr.href]="linkPath" data-crlat="titleText">
                        {{ loading() ? '' : titleText }}
                    </a>
                }
            </span>
        }
        @if (!seoEnabledInCms && !isHorseRacingDetailPage && isRouteRequestSuccess) {
            <h1 class="top-bar-title bar-title" data-crlat="topBarTitle" (click)="titleClickHandler()">
                @if (iconId) {
                    <svg-list [list]="iconSvg"></svg-list>
                }
                @if (titleText) {
                    <a [attr.href]="linkPath" data-crlat="titleText">
                        {{ loading() ? '' : titleText }}
                    </a>
                }
            </h1>
        }
        @if (isHorseRacingDetailPage || !isRouteRequestSuccess) {
            <div class="top-bar-title">
                <ng-content select="breadcrumbs"></ng-content>
                <ng-content select="quick-navigation"></ng-content>
            </div>
        }
        <div>
            <ng-content select="[changeMatch]"></ng-content>
        </div>
        @if (innerContent) {
            <div>
                <ng-content select="top-bar-body"></ng-content>
            </div>
        }
    </header>
}
